export async function saveMemberProfileUpdate(api, draft, user) {
  const isAdmin = user?.role === 'admin';
  let endpoint = '/accounts/profile/';

  if (isAdmin) {
    endpoint = `/accounts/admin/members/${encodeURIComponent(draft.profileId)}/`;
  } else {
    const profileResponse = await api.get(endpoint);
    if (String(profileResponse.data.id) !== String(draft.profileId)) {
      const error = new Error(
        'The signed-in account does not match the member selected for this update.'
      );
      error.code = 'PROFILE_MISMATCH';
      throw error;
    }
  }

  const data = new FormData();
  [
    'first_name',
    'last_name',
    'phone_number',
    'email',
    'firm_address',
    'employment_category',
  ].forEach((field) => data.append(field, draft.fields[field]));
  if (draft.photoFile) data.append('photo', draft.photoFile);

  const response = await api.patch(endpoint, data);
  return response.data;
}

export function getProfileUpdateError(error) {
  const data = error.response?.data;
  if (error.response?.status === 404 && data?.detail === 'Profile not found.') {
    return 'This account is not linked to a member profile. Sign in with the member account or contact the secretariat.';
  }
  if (data?.detail) return data.detail;
  if (data && typeof data === 'object') {
    const messages = Object.values(data).flat().filter(Boolean);
    if (messages.length) return messages.join(' ');
  }
  return error.message || 'Unable to save the profile update. Please try again.';
}
